import Swal from "sweetalert2";
import { BiChevronDown } from "react-icons/bi";

import Dropdown from "../../../components/Dropdown";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";

import { useAppDispatch } from "../../../store/hooks";
import { skills, deleteSkill } from "../../../store/roles_skills";
import EditSkill from "./edit";

interface Props {
  skill: skills;
}

const OneSkill = ({ skill }: Props) => {
  const dispatch = useAppDispatch();

  const delSkill = () => {
    Swal.fire({
      title: "You are about to delete a skill",
      text: "This change can't be reversed",
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: "Yes, confirm",
    }).then((isConfirmed) => {
      if (isConfirmed.isConfirmed) {
        dispatch(deleteSkill({ id_encrypted: skill.id_encrypted }));
      }
    });
  };

  const { isShown: isModalShown, toggle: ToggleModal } = useModal();

  const Optiosn = (
    <div className="c-list-options">
      <span className="c-list-options__item" onClick={ToggleModal}>
        Edit Skil
      </span>
      <span className="c-list-options__item" onClick={delSkill}>
        Delete Skill
      </span>
    </div>
  );

  return (
    <>
      <Modal
        isActive={isModalShown}
        clouse={ToggleModal}
        title="Edit Skill"
        key={skill.id}
        id={skill.id}
      >
        <EditSkill
          isShown={isModalShown}
          skill={skill}
          toggle={ToggleModal}
          // id_user={employee.id_encrypted}
          // employeeBrands={employee.brands}
        />
      </Modal>
      <tr key={skill.skill}>
        {/*  <td className="c-table__trbody"><input type="checkbox" id="cbox1" value="first_checkbox" /></td> */}
        <td className="c-table__trbody">{skill.id}</td>
        <td className="c-table__trbody">{skill.skill}</td>
        <td className="c-table__trbody">{skill.slug}</td>

        <td className="c-table__trbody">
          <Dropdown overlay={Optiosn} placement="bottom-end" margin={0}>
            <button className="c-table__actions">
              Actions <BiChevronDown />
            </button>
          </Dropdown>
        </td>
      </tr>
    </>
  );
};

export default OneSkill;
